import SimplePage from "../components/site/SimplePage";

const sections = [
  {
    title: "Photo Stories",
    text: "Visual highlights from learning centers, health camps, and community celebrations."
  },
  {
    title: "Video Library",
    text: "Short documentaries and interviews featuring beneficiaries and volunteers."
  },
  {
    title: "Press Releases",
    text: "Official announcements, partnership updates, and campaign milestones."
  }
];

function Media() {
  return (
    <SimplePage
      title="Media"
      lead="Explore stories, photos, and video features that capture our mission in action."
      sections={sections}
    />
  );
}

export default Media;
